import React, { forwardRef, useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { PropTypes } from 'prop-types'
import DataConfirmation from '../DataConfirmation'
import ContainerFields from './ContainerFields'
import useQuotationClient from '../../../../clients/QuotationClient/useQuotationClient'

const Confirmation = forwardRef((props, ref) => {
  const { quotation, proposal, quotationStatus } = props
  const { state } = useLocation()
  const quotationClient = useQuotationClient()
  const [quoteAiData, setQuoteAiData] = useState(null)

  useEffect(() => {
    if (state?.submittedDocumentId) {
      quotationClient().getSubmittedDocument(state.submittedDocumentId).then((response) => {
        setQuoteAiData(response.data)
      }, () => {
        //
      })
    }
  }, [state?.submittedDocumentId, quotationClient])

  return (
    <>
      <DataConfirmation
        ref={ref}
        {...props}
      >
        <ContainerFields
          quotation={quotation}
          proposal={proposal}
          quotationStatus={quotationStatus}
          quoteAiData={quoteAiData}
        />
      </DataConfirmation>
    </>
  )
})

Confirmation.propTypes = {
  quotation: PropTypes.any.isRequired,
  proposal: PropTypes.any,
  quotationStatus: PropTypes.any.isRequired,
}

Confirmation.defaultProps = {
  proposal: {},
}

export default Confirmation
